import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "px-2 scenario-share" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && typeof(_ctx.learner_brief_scenario) !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[0] || (_cache[0] = _createElementVNode("p", null, "Welcome! You are about to meet your standardized patient. Please ensure your camera and microphone are switched on.", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("p", null, [
              _createTextVNode("Once you have reviewed the patient note, you can "),
              _createElementVNode("u", null, "begin anytime."),
              _createElementVNode("br"),
              _createElementVNode("strong", { style: {"color":"#112c54"} }, "To begin the simulation,"),
              _createTextVNode(" please greet your patient by name.")
            ], -1)),
            _createElementVNode("p", null, "Today's Patient: " + _toDisplayString(_ctx.patient_name), 1),
            _createElementVNode("div", {
              class: "px-4",
              innerHTML: _ctx.learner_brief_scenario
            }, null, 8, _hoisted_3),
            _cache[2] || (_cache[2] = _createElementVNode("p", null, "When you feel you have met the scenario's objectives, you may wrap up the visit as you would in a typical patient encounter.", -1))
          ])
        ]))
      : (!_ctx.loading && typeof(_ctx.learner_brief_scenario) === 'undefined')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[3] || (_cache[3] = [
            _createElementVNode("p", null, "Error Loading Scenario", -1)
          ])))
        : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}